import type { ComponentType } from 'react'

import { brandAssetUrl } from '@/runtime'

import styles from './LumaIcon.module.scss'

export interface NavigationIconProps {
  'aria-hidden'?: boolean | 'true' | 'false'
  className?: string
}

export type NavigationIcon = ComponentType<NavigationIconProps>

export function LumaIcon({
  animated = false,
  className,
  muted = false,
}: NavigationIconProps & { animated?: boolean; muted?: boolean }) {
  const assetName = animated ? 'luma-ready.svg' : 'progetto-arca-symbol-color.png'

  return (
    <span
      className={`${styles.icon} ${muted ? styles.muted : ''} ${className ?? ''}`}
      data-brand-icon="true"
      aria-hidden
    >
      <img
        key={assetName}
        className={styles.image}
        src={brandAssetUrl(assetName)}
        alt=""
        draggable={false}
      />
    </span>
  )
}

export function LumaNavigationIcon(props: NavigationIconProps) {
  return <LumaIcon {...props} muted />
}
